import { type FC } from 'react';

import { Permission } from '@/api/permissions/models/Permission';
import { useHasPermission } from '@/components/Permissions/useHasPermission';
import { LatestMonthlyReportsWidget } from '@/components/Widgets/Reports';
import { WithGap } from '@/components/WithGap';

import { NewsArticlesWidget } from './NewsArticlesWidget';

/**
 * Component to be displayed on the dashboard when the organization has no portfolios.
 *
 * A scenario in which the organization has no portfolios occurs when
 * it is an 'umbrella' organization with sub-organizations that have
 * portfolios, but the organization itself has none.
 */
export const NoPortfoliosDashboard: FC = () => {
  const hasPermission = useHasPermission();

  return (
    <div data-test="no-portfolios-dashboard">
      <WithGap gap="96">
        {hasPermission(Permission.ReportsRead) && (
          <LatestMonthlyReportsWidget />
        )}

        <NewsArticlesWidget />
      </WithGap>
    </div>
  );
};
